import { LogoGrowegy } from '../../../assets/icons';
import React from 'react';

export const AuthBannerDefault = () => {
  return (
    <div className="auth-content">
      <div className="auth-content__title">
        <img src={LogoGrowegy} className="auth-content__logo" alt="Logo" />
        <div className="auth-content__name">Growegy</div>
      </div>
      <div className="auth-content__subtitle">Make Your Business Lendable</div>
      <ul className="auth-content__list">
        <li className="list-item">
          <strong>Build Business Credit:</strong> Growegy operates on NET30 terms and reports
          monthly to Experian and Equifax.
        </li>
        <li className="list-item">
          <strong>Generate Business Plans:</strong> The Growegy AI Assistant allows you to quickly
          create a personalized business plan, positioning you better for growth and funding.
        </li>
        <li className="list-item">
          <strong>Create Content with AI:</strong> Our AI saves your business time and money. It is
          always ready to draft initial content, find information, or create promotional campaigns,
          allowing you to focus on higher-level tasks.
        </li>
        <li className="list-item">
          <strong>Manage Business Projects:</strong> Benefit from a project management calendar, a
          dedicated account manager, and marketing agency services to help your business launch
          promotions and gain visibility.
        </li>
        <li className="list-item">
          <strong>Find the Best Offers in Our Marketplace:</strong> Growegy provides a curated
          selection of partner services tailored specifically for small businesses, offering
          exclusive bonuses and discounts to enhance your experience.
        </li>
        <li className="list-item">
          <strong>Access Loyalty Benefits:</strong> These included marketing services are designed
          to support small business owners and are tailored to elevate your brand and help you
          attract more customers.
        </li>
      </ul>
    </div>
  );
};
